import { message } from 'antd';
import {
  SuccessIcon,
  FailureIcon,
  AlertIcon
} from './iconLibrary';
import styles from './style.module.scss';
export const cusSuccessMessage = (content, duration = 5) => {
  message.config({
    prefixCls: "custom-message"
  });
  message.error({
    content,
    duration,
    onClose: () => {},
    icon: <SuccessIcon className={styles.msgIcon} />
  });
};

export const cusErrorMessage = (content, className="custom-message") => {
  message.config({
    prefixCls: className
  });
  message.error({
    content,
    duration: 5,
    onClose: () => {},
    icon: <FailureIcon className={styles.msgIcon} />
  });
};

export const cusWarnMessage = (content, duration = 5) => {
  message.config({
    prefixCls: "custom-message"
  });
  message.error({
    content,
    duration,
    onClose: () => {},
    icon: <AlertIcon className={styles.msgIcon} />
  });
};
